import { FC } from 'react';
import { Box, Typography } from '@mui/material';

import styles from './TravelContacts.module.scss';
import { TravelContactsIcon } from '../../../../../../../components/Icons';

interface TravelContactsProps {
  onClick?: () => void;
}

const TravelContacts: FC<TravelContactsProps> = ({ onClick }) => {
  const handleClick = () => {
    onClick?.();
  };

  return (
    <Box className={styles.travelContacts}>
      <button
        className={styles.contactsButton}
        onClick={handleClick}
      >
        <TravelContactsIcon size={24} />
        <Typography
          variant="h11"
          className={styles.contactsText}
        >
          Travel Contacts
        </Typography>
      </button>
    </Box>
  );
};

export default TravelContacts;
